module.exports = __webpack_public_path__ + "img/56400.da2a845f.jpg";